import {IRiskFactor, IUtmResponse, IUtmStandard} from '../types';

export function formatScoreFactores(obj: Record<string, any>): IRiskFactor[] {
  return Object.entries(obj)
    .map(([title, value]) => ({
      title,
      score: value['امتیاز'],
      bullets: value['جزییات'],
    }))
    .filter(i => i.title !== 'امتیاز کل');
}

export function formatFarmData(utm: IUtmResponse): IUtmStandard {
  return {...utm, coordinates: utm.coordinates[0][0]};
}

export function toPersianHectareText(value: string | number): string {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  const hectares = Math.floor(num);
  const squareMeters = Math.round((num - hectares) * 10000);

  return !!num
    ? `${!!hectares ? `${hectares} هکتار  ` : ''} ${
        !!hectares && !!squareMeters ? 'و' : ''
      } ${!!squareMeters ? `${squareMeters} متر مربع` : ''}`
    : '-';
}

export function splitCoordinates(coordinates: [number, number][]): {
  xData: string[];
  yData: string[];
} {
  const x: string[] = [];
  const y: string[] = [];

  coordinates.slice(0, -1).forEach(([lng, lat]) => {
    x.push(lng.toFixed(2).toString());
    y.push(lat.toFixed(2).toString());
  });

  return {xData: x, yData: y};
}

export function getShamsiDate(date: Date = new Date()): string {
  const formatter = new Intl.DateTimeFormat('en-US-u-ca-persian-nu-latn', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  const parts = formatter.formatToParts(date);

  const year = parts.find(p => p.type === 'year')?.value;
  const month = parts.find(p => p.type === 'month')?.value;
  const day = parts.find(p => p.type === 'day')?.value;

  return `${year}/${month}/${day}`;
}

export function getTimeString(date: Date = new Date()): string {
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
}

export function fixRtlNumberStart(text: string): string {
  return `\u200F${text}`;
}
